module.exports = __webpack_public_path__ + "media/fuel_types/lpg-d6aca656.svg";